import MainHeroHeader from "../components/Home/MainHeroHeader";
import HomeContentLayout from "../components/Home/HomeContentLayout";
import "./Home.css";

const Home = () => {
  return(
    <div id="home-wrapper">
      <MainHeroHeader />
      <HomeContentLayout />
    </div>
  ) 
};

export default Home;
